import React from "react";
import { cn } from "../../lib/utils";
import FraudLCMSText from "./FraudLCMSText";
import CansoIcon from "./CaseInfoIcon";

interface SidebarHeaderProps {
  isCollapsed: boolean;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isCollapsed }) => {
  return (
    <div
      className={cn(
        "flex items-center px-4 py-2 mt-2",
        isCollapsed ? "justify-center px-2" : "justify-start gap-[5.76px]"
      )}
    >
       <CansoIcon  />
      {!isCollapsed && <FraudLCMSText className="flex-shrink-0" />}
    </div>
  );
};

export default SidebarHeader;